import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

/**
 * Read-only status row for an EHR-driven item that checks off automatically when
 * the source system reports it (e.g. transfer order, clinical/social stability,
 * consent). Not actionable — purely a display.
 */
interface Props {
  done: boolean;
  title: string;
  detail?: React.ReactNode; // shown when done
  pendingText?: string;     // shown when not done
}

const EhrStatusRow: React.FC<Props> = ({ done, title, detail, pendingText = 'Not yet received from the EHR' }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
    {done ? (
      <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24, mt: '1px' }} />
    ) : (
      <RadioButtonUncheckedIcon sx={{ color: 'text.disabled', fontSize: 24, mt: '1px' }} />
    )}
    <Box>
      <Typography variant="body1" sx={{ fontWeight: 600 }}>{title}</Typography>
      <Typography variant="body2" color="text.secondary">
        {done ? detail : pendingText}
      </Typography>
    </Box>
  </Box>
);

export default EhrStatusRow;
